const BannerTypes = [
  {
    label: "اسلایدر",
    value: "0",
  },
  {
    label: "عادی",
    value: "1",
  },
];

const BannerOrders = Array(10)
  .fill(0)
  .map((v, i) => ({
    label: "" + (i + 1),
    value: "" + (i + 1),
  }));

export { BannerTypes, BannerOrders };
